export default __webpack_public_path__ + "static/media/main-hero-image.fa3a1f4d.png";